import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { formatUrl } from '../../molecules/journal/utils';
import { Link } from '../link/Link';
import styles from './Tag.module.scss';

const Tag = ({ name, url, className }) => {
  const classes = clsx(styles.tag, className);

  return url ? (
    <Link to={formatUrl(url)} className={classes}>
      {name}
    </Link>
  ) : (
    <div className={classes}>{name}</div>
  );
};

Tag.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Tag.defaultProps = {
  className: '',
};

export default Tag;
